import { render, staticRenderFns } from "./LegendBar.vue?vue&type=template&id=a3c5e1a2&scoped=true&"
import script from "./LegendBar.vue?vue&type=script&lang=js&"
export * from "./LegendBar.vue?vue&type=script&lang=js&"
import style0 from "./LegendBar.vue?vue&type=style&index=0&id=a3c5e1a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c5e1a2",
  null
  
)

export default component.exports